import { SR_API_ACTION_FLOOR_PLAN_GET_LIST_BY_APARTMENT_ID } from 'api/actionTypes';

export default async function getFloorPlansListByApartmentId(
  { state, apiClient },
  { apartmentId },
) {
  const statePath = ['floorPlans', 'listByApartmentId', apartmentId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_FLOOR_PLAN_GET_LIST_BY_APARTMENT_ID,
    state: state,
    payload: {
      apartmentId,
    },
    onSuccess(floorPlans) {
      state.set(statePath, floorPlans);
    },
  });
}
